
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';


export const languages = [
    { 
        code: 'it-IT', 
        label: 'Italiano', 
        codeApi: 'it', 
        default: true,
        url: './assets/images/italy.png',
        text: 'IT',
        sitemap: 'sitemap.xml',
        locale: localeIt,
        showOnlyInNodeType: "",
        routeCookiePolicy: "it/cookie-policy"
    },  
    { 
        code: 'en-EN', 
        label: 'English', 
        codeApi: 'en', 
        default: false,
        url: './assets/images/united-kingdom.png',
        text: 'EN',
        sitemap: 'sitemap-en.xml' ,
        locale: localeEn,
        showOnlyInNodeType: "",
        routeCookiePolicy: "en/cookie-policy-eng"
    },
    { 
        code: 'es-ES', 
        label: 'Spagnolo', 
        codeApi: 'es', 
        default: false,
        url: './assets/images/spain.png',
        text: 'ES',
        sitemap: 'sitemap-es.xml' ,
        locale: localeEs,
        showOnlyInNodeType: "pagina",
        routeCookiePolicy: "es/cookie-policy-es"
    },
    { 
        code: 'fr-FR', 
        label: 'Francese', 
        codeApi: 'fr', 
        default: false,
        url: './assets/images/france.png',
        text: 'FR',
        sitemap: 'sitemap-fr.xml' ,
        locale: localeFr,
        showOnlyInNodeType: "pagina",
        routeCookiePolicy: "fr/cookie-policy-fr"
    }
];